import {isEmpty} from "lodash"

export const showFilterTags = <T extends any>(tags: T): boolean => {
  return !isEmpty(tags) && tags.length > 1
}
